import styled from "@emotion/styled";
import { RichTextStyle } from "../RichText";
var NavContainer = /*#__PURE__*/ styled("div", {
    target: "eg7ht0v0"
})("width:100%;");
var Nav = /*#__PURE__*/ styled("nav", {
    target: "eg7ht0v1"
})("border-bottom:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return "1px solid ".concat(textStyle === RichTextStyle.Alternative ? theme.color.natural0 : theme.color.natural20);
}, ";margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";gap:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";padding-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";scrollbar-width:none;overflow:auto clip;display:flex;");
export { Nav, NavContainer };
